"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListPropertySummaryDetailDto = instanceOfListPropertySummaryDetailDto;
exports.ListPropertySummaryDetailDtoFromJSON = ListPropertySummaryDetailDtoFromJSON;
exports.ListPropertySummaryDetailDtoFromJSONTyped = ListPropertySummaryDetailDtoFromJSONTyped;
exports.ListPropertySummaryDetailDtoToJSON = ListPropertySummaryDetailDtoToJSON;
exports.ListPropertySummaryDetailDtoToJSONTyped = ListPropertySummaryDetailDtoToJSONTyped;
/**
 * Check if a given object implements the ListPropertySummaryDetailDto interface.
 */
function instanceOfListPropertySummaryDetailDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    return true;
}
function ListPropertySummaryDetailDtoFromJSON(json) {
    return ListPropertySummaryDetailDtoFromJSONTyped(json, false);
}
function ListPropertySummaryDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'address': json['address'],
        'type': json['type'],
        'price': json['price'],
        'phoneNumber': json['phoneNumber'],
    };
}
function ListPropertySummaryDetailDtoToJSON(json) {
    return ListPropertySummaryDetailDtoToJSONTyped(json, false);
}
function ListPropertySummaryDetailDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'address': value['address'],
        'type': value['type'],
        'price': value['price'],
        'phoneNumber': value['phoneNumber'],
    };
}
